<div class="form-content form-container" [attr.data-form-name]="dynamicFormArray.formName">
    <form [formGroup]="form" class="mat-form">
        <main class="form-wrapper">
            @for (field of dynamicFormArray['FieldsArray']; track idx; let idx = $index) {
            <div class="dynamic-input-field"
                [ngClass]="field.fieldCriteriaConfig? 'dynamic-'+field['fieldType']+'-container criteria-field-main-container': 'dynamic-'+field['fieldType']+'-container'"
                [hidden]="field.hidden">
                @switch (field.fieldType) {
                @case (FieldType.DROPDOWN) {
                <app-mat-dropdown-field [field]="field" (selectionChanged)="onValueChanged($event)"
                    [form]="form"></app-mat-dropdown-field>
                }
                @case (FieldType.TEXT) {
                <app-mat-text-field [field]="field" (inputChanged)="onValueChanged($event)"
                    [form]="form"></app-mat-text-field>
                }
                @case (FieldType.EMAIL) {
                <app-mat-text-field [field]="field" (inputChanged)="onValueChanged($event)"
                    [form]="form"></app-mat-text-field>
                }
                @case (FieldType.NUMBER) {
                <app-mat-text-field [field]="field" (inputChanged)="onValueChanged($event)"
                    [form]="form"></app-mat-text-field>
                }
                @case (FieldType.DATE) {
                <app-mat-date-field [field]="field" (dateChange)="onValueChanged($event)"
                    [form]="form"></app-mat-date-field>
                }
                @case (FieldType.TEXTAREA) {
                <app-mat-textarea [field]="field" (inputChanged)="onValueChanged($event)"
                    [form]="form"></app-mat-textarea>
                }
                @case (FieldType.FILE) {
                <app-mat-file-upload [field]="field" (fileSelected)="onValueChanged($event)"
                    [form]="form"></app-mat-file-upload>
                }
                @case (FieldType.CHECKBOX) {
                @if(!props.showJobRoleContainer){
                <app-mat-checkbox-list-field [field]="field" (selectionChanged)="onValueChanged($event)"
                    [form]="form"></app-mat-checkbox-list-field>
                }
                }
                }
            </div>
            }
            @if(props && props.showJobRoleContainer){
            <div class="job-selection-form-container" onKeyDown="" (click)="openJobRoleSelection($event)">
                <div class="title"> Job Role Selection <span class="title-hint">
                        <i class="fa-regular fa-hand-pointer"></i>
                        Click to select Job Roles
                    </span></div>
                <div class="selection-cotainer">@if(!showJobRoleContainer){<i class="fa-solid fa-maximize"></i>}@else{<i
                        class="fa-solid fa-minimize"></i>}
                </div>
            </div>
            <app-distribution-list-filter-container [showJobRoleContainer]="showJobRoleContainer" [isReset]="isJobReset"
                [dynamicFormArray]="dynamicFormArray" [form]="form" (selectionChange)="onValueChanged($event)"
                (closeCliked)="closeJobRoleSelection()"></app-distribution-list-filter-container>
            }
            @if(props && props["optionExplanation"]){
            <div>
                @if(props['optionExplanation'].length == 1){
                <span style="font-size: var(--cbl-header-font-size);"><b>Note:-
                    </b>{{props['optionExplanation'][0]}}</span>
                }@else{
                <ul class="optionExplain">
                    @for(info of props["optionExplanation"]; track info){
                    <li>{{ info }}</li>
                    }
                </ul>
                }
            </div>
            }
        </main>



        @if(dynamicFormArray.ButtonsArray && dynamicFormArray.ButtonsArray.length>0 && hasVisibleFooterButtons()){
        <footer class="footer">
            @for(buttonField of dynamicFormArray.ButtonsArray; track idx; let idx = $index){
            @if(shouldShowFooterButton(buttonField.name)){
            <app-button-field (buttonClicked)="onButtonClicked(buttonField.name)" onKeyDown=""
                [buttonConfig]="buttonField" [isLoading]="!!DataTableSchema?.isLoading"></app-button-field>
            }
            }
        </footer>
        }
    </form>
</div>